import { useState } from 'react'
import emailjs from 'emailjs-com'

const initialState = {
  name: '',
  email: '',
  message: '',
}
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState)

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }
  const clearState = () => setState({ ...initialState })

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(name, email, message)
    emailjs
      .sendForm(
        'service_jg3b2ib', 'template_056rr6v', e.target, 'EemXM7Teyyt3gMdko'
      )
      .then(

        (result) => {
          console.log(result.text)
          clearState()
        },
        (error) => {
          console.log(error.text)
        },
      )
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Liên Hệ</h2>
                <p>
                Nếu bạn có thắc mắc gì, có thể gửi yêu cầu cho chúng tôi, và chúng tôi sẽ liên lạc lại với bạn sớm nhất có thể.
                </p>
              </div>
              <form name='sentMessage' validate onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Tên của bạn'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Lời nhắn '
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Gửi Lời Nhắn
                </button>
              </form>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Thông Tin Liên Hệ</h3>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Địa Chỉ
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-mobile'></i> Điện Thoại Di Động
                </span>{' '}
                <a href={"tel:"+ (props.data ? props.data.mobilephone : 'loading')}>{props.data ? props.data.mobilephone : 'loading'}</a>
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Điện Thoại Bàn
                </span>{' '}
                <a href={"tel:" + (props.data ? props.data.phone : 'loading')}>{props.data ? props.data.phone : 'loading'}</a>
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-university'></i> SACOMBANK
                </span>{' '}
                {props.data ? props.data.bank : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-clock-o'></i> Giờ Mở Cửa
                </span>{' '}
                {props.data ? props.data.open_time : 'loading'}
              </p>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                    <i className="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.viber : '/'}>
                      <i className='fa-brands fa-viber'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.zalo : '/'}>
                    <i className="fa-brands icon-zalo"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2022 Quầy Vải Huê Trí. Design by{' '}
            <a href= 'https://www.linkedin.com/in/tai-nguyen-vl/' rel='nofollow'>
              Tai Nguyen
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
